import React from "react";
import Form from "react-bootstrap/Form";
import './Questionnaire.css';
import { Link } from "react-router-dom";
import QuestionnaireDataService from "../../services/questionnaire.service";
import LoggerDataService from "../../services/logger.service";
import SignUpDataService from "../../services/signup.service";
import Updated from "../Messages/Updated";
import Error from "../Error/Error";

class Questionnaire extends React.Component{

  constructor(props) {
    const isLoggedIn = window.localStorage.getItem("userid") ? true : false;
    let userid = 0;
    if(isLoggedIn)
    {
    userid = window.localStorage.getItem("userid");
    }
    super(props);
    this.state = {
      stage: 0,
      questionnaire_0: 0,
      questionnaire_1: 0,
      questionnaire_2: 0,
      questionnaire_3: 0,
      questionnaire_4: 0,
      questionnaire_5: 0,
      questionnaire_6: 0,
      questionnaire_7: 0,
      questionnaire_8: 0,
      questionnaire_9: 0,
      allquestions: [{ q: 'Do you love to travel?', a: 0} , {q: 'Do you consider yourself to be a social butterfly?',a: 0}, {q: 'Are you career minded?', a: 0},
      {q: 'Is a good educational background important?', a: 0},{q: 'Are you a foodie?', a: 0}, {q: 'Are you organized?', a: 0},
      {q: 'Do you enjoy working out?', a: 0}, {q: 'Do you enjoy visiting the Museums?', a: 0}, {q: 'Do you like to watch Movies in theatres?', a: 0},
      {q: 'Do you enjoy being around large crowds?', a: 0}],
      userid: userid
      
    };

  }

  async updateQuestionnaire(user_id) {

    var data = {
      questionnaire_0: parseInt(this.state.questionnaire_0),
      questionnaire_1: parseInt(this.state.questionnaire_1),
      questionnaire_2: parseInt(this.state.questionnaire_2),
      questionnaire_3: parseInt(this.state.questionnaire_3),
      questionnaire_4: parseInt(this.state.questionnaire_4),
      questionnaire_5: parseInt(this.state.questionnaire_5),
      questionnaire_6: parseInt(this.state.questionnaire_6),
      questionnaire_7: parseInt(this.state.questionnaire_7),
      questionnaire_8: parseInt(this.state.questionnaire_8),
      questionnaire_9: parseInt(this.state.questionnaire_9)

    };


    await QuestionnaireDataService.update(user_id, data)
    .then(response => {
   
      if(parseInt(response.data.message) === 1)
      {
        //display updated comppnent
        this.setState({stage: 2});
      }
      else
      {
        //display unable to updated component
        this.setState({stage: 3});
      }
    
    })
    .catch(e => {
      console.log(e);
    });

  }

  completeQuestionnaire() {

    var data = {
      questionnaire_0: parseInt(this.state.questionnaire_0),
      questionnaire_1: parseInt(this.state.questionnaire_1),
      questionnaire_2: parseInt(this.state.questionnaire_2),
      questionnaire_3: parseInt(this.state.questionnaire_3),
      questionnaire_4: parseInt(this.state.questionnaire_4),
      questionnaire_5: parseInt(this.state.questionnaire_5),
      questionnaire_6: parseInt(this.state.questionnaire_6),
      questionnaire_7: parseInt(this.state.questionnaire_7),
      questionnaire_8: parseInt(this.state.questionnaire_8),
      questionnaire_9: parseInt(this.state.questionnaire_9),
      userid: parseInt(this.state.userid)

    };

    
    QuestionnaireDataService.create(data)
      .then(response => {
        this.setState({
          questionnaire_0: response.data.questionnaire_0,
          questionnaire_1: response.data.questionnaire_1,
          questionnaire_2: response.data.questionnaire_2,
          questionnaire_3: response.data.questionnaire_3,
          questionnaire_4: response.data.questionnaire_4,
          questionnaire_5: response.data.questionnaire_5,
          questionnaire_6: response.data.questionnaire_6,
          questionnaire_7: response.data.questionnaire_7,
          questionnaire_8: response.data.questionnaire_8,
          questionnaire_9: response.data.questionnaire_9
        });
      
      })
      .catch(e => {
        console.log(e);
      });
  }


  handleSubmit = async (event) => {
    event.preventDefault();
    if(parseInt(this.state.userid) === 0)
    return;

    this.setState({stage: 0});
    QuestionnaireDataService.get(parseInt(this.state.userid))
    .then(response => {

      let data ={
        questionnaire: 1
      }

      if(response.data != '')
      {
        this.updateQuestionnaire(parseInt(this.state.userid));
        this.setState({stage: 2})
        SignUpDataService.update(this.state.userid, data)
        .then(res => {
          
        });

      }
      else if(response.data == '')
      {
        this.completeQuestionnaire();
        this.setState({stage: 1});
        SignUpDataService.update(this.state.userid, data)
        .then(res => {
          
        });
      }
      else
      {
        //error panel
        let errorData = {
          message: "Error in Questionnaire",
          category: 1,
          userid: this.state.userid
        }
      
        LoggerDataService.create(errorData)
        .then(res => {
  
        });
        this.setState({stage: 3})
      }

    });


  }

  onChangeValue(event,index) {
    
    let q = event.target.name;
    this.setState({[q]: event.target.value})
    let newArray = [...this.state.allquestions];
    newArray[index] = {...newArray[index], a: event.target.value};
    this.setState({
      allquestions: newArray,
      });
 
  }

  home = () => {

  }

  validateForm = () => {
    return this.state.questionnaire_0 !=  '' && this.state.questionnaire_1 !=  '' && this.state.questionnaire_2 !=  ''  && this.state.questionnaire_3 !=  '' && this.state.questionnaire_4 !=  '' && this.state.questionnaire_5 !=  '' && this.state.questionnaire_6 !=  '' && this.state.questionnaire_7!=  ''  && this.state.questionnaire_8 !=  '' && this.state.questionnaire_9 !=  '';
  }


  componentDidMount() {

    //get questionnaires by user id
    QuestionnaireDataService.get(this.state.userid)
    .then(response => {
      if(response.data != '')
      {
      this.setState({
        questionnaire_0: response.data.questionnaire_0,
        questionnaire_1: response.data.questionnaire_1,
        questionnaire_2: response.data.questionnaire_2,
        questionnaire_3: response.data.questionnaire_3,
        questionnaire_4: response.data.questionnaire_4,
        questionnaire_5: response.data.questionnaire_5,
        questionnaire_6: response.data.questionnaire_6,
        questionnaire_7: response.data.questionnaire_7,
        questionnaire_8: response.data.questionnaire_8,
        questionnaire_9: response.data.questionnaire_9
      });


      this.setState({allquestions: [{ q: 'Do you love to travel?', a: parseInt(this.state.questionnaire_0)} , {q: 'Do you consider yourself to be a social butterfly?', a: parseInt(this.state.questionnaire_1)}, {q: 'Are you career minded?', a:parseInt(this.state.questionnaire_2)},
      {q: 'Is a good educational background important?', a: parseInt(this.state.questionnaire_3)},{q: 'Are you a foodie?', a: parseInt(this.state.questionnaire_4)}, {q: 'Are you organized?', a: parseInt(this.state.questionnaire_5)},
      {q: 'Do you enjoy working out?', a: parseInt(this.state.questionnaire_6)}, {q: 'Do you enjoy visiting the Museums?', a: parseInt(this.state.questionnaire_7)}, {q: 'Do you like to watch Movies in theatres?', a: parseInt(this.state.questionnaire_8)},
      {q: 'Do you enjoy being around large crowds?', a: parseInt(this.state.questionnaire_9)}] });
    }

    })
    .catch(e => {
      console.log(e);
    });

   
  }


render(){
return (
  <div className="container col-md-12">
  <Form onSubmit={this.handleSubmit}>
  <div className="row background-questions">
  <div className="col-md-12 front-text">
  {this.state.stage == 1 ? <Updated Color={'accept-color'} Message={'Questionnaire created.'}/> : ''}
  {this.state.stage == 2 ? <Updated Color={'accept-color'} Message={'Questionnaire updated.'}/> : ''}
  {this.state.stage == 3 ? <Error Message={'Unable to update Questionnaire. Contact Help desk.'}/> : ''}
  </div>
    <br/>
    {this.state.allquestions.map((person, index) => (
      <div key={"key" + index} className="col-md-5 radio-size">
        <Form.Label className="text-float">{person.q}</Form.Label>
        <Form.Control value={person.a} key={"questionnaire_" + index} name={"questionnaire_" + index}   as="select" className="radio-input" onChange={(e) => { this.onChangeValue(e, index)} } >    
           <option></option>
           <option key={"questionnaire_y_" + index} value="1">Yes</option>
           <option key={"questionnaire_n_" + index} value="2">No</option>
           <option key={"questionnaire_s_" + index} value="3">Sometimes</option>
        </Form.Control>
      </div> 
    ))}
   <div className="row col-sm-12">
   <div className="col-sm-2 offset-6">
  
        <button type="submit" disabled={!this.validateForm()}><img width="75" src="save.png" alt="save" /></button>
        <Link  to="/home"><img width="75" src="home.png" alt="save" /></Link>
        </div> 
        <div className="col-sm-2">

       
        </div>
    </div>
       </div>
       </Form>

  </div>
);
}

}

export default Questionnaire;